import { CMSBlock } from "@tudigo-monorepo/core-tudigo-api-models";

export enum ArticleStatus {
  Draft = "draft",
  Review = "review",
  Published = "published",
}

export interface Article {
  id: string;
  title: string;
  description: string;
  content: CMSBlock[];
  status: ArticleStatus;
}
